import { SagaIterator } from 'redux-saga';
import { spawn } from 'redux-saga/effects';
import { saga as local } from './ducks/local';

export default function* Saga(): SagaIterator {
  yield spawn(local);
}
